import { css } from "@emotion/react";
import { Suspense, useState } from "react";
import { Helmet } from "react-helmet";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { getHostMeta, hostMap } from "./hosts";
import UnknownHost from "./hosts/UnknownHost";
import UnsupportedHost from "./hosts/UnsupportedHost";

export default function HostDump() {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>Host Instructions</title>
            </Helmet>
            <h1>Host Instructions</h1>
            <div css={css`display: flex;`}>
                <div>
                    <table style={{ marginRight: "2rem", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: "left" }}>Host</th>
                                <th style={{ textAlign: "center" }}>Supported?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(hostMap).map(key => (
                                <tr
                                    key={key}
                                    onClick={() => navigate(key)}
                                    css={css`&:hover { background: #ccf; cursor: pointer; }`}
                                >
                                    <td
                                        style={{
                                            textAlign: "left",
                                            padding: "0.25rem",
                                            fontWeight:
                                                hostMap[key].supported !== "YES" ||
                                                hostMap[key].instructions
                                                    ? "bold"
                                                    : "normal"
                                        }}
                                    >
                                        {hostMap[key].name ?? key}
                                    </td>
                                    <td style={{ textAlign: "center", padding: "0.25rem" }}>
                                        {hostMap[key].supported}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div style={{ flex: 1, border: "2px solid #ddd", padding: "2rem" }}>
                    <Routes>
                        <Route index element={<p>select a host to view instructions</p>} />
                        <Route path=":hostKey" element={<Instructions />} />
                    </Routes>
                </div>
            </div>
        </>
    );
}

function Instructions() {
    const { hostKey } = useParams(),
        meta = getHostMeta(hostKey),
        Component = meta?.instructions;
    return (
        <>
            <Helmet>
                <title>{meta.name}</title>
            </Helmet>
            <h1 style={{ marginTop: 0 }}>{meta.name}</h1>
            {meta.supported == "YES" ? (
                Component ? (
                    <Suspense fallback="Loading...">
                        <Component />
                    </Suspense>
                ) : (
                    <p>[ no instructions yet ]</p>
                )
            ) : meta.supported == "NO" ? (
                <UnsupportedHost name={meta.name} />
            ) : (
                <UnknownHost />
            )}
        </>
    );
}
